module.exports = __webpack_public_path__ + "assets/img/news (40).c8271870.png";